import * as React from "react";
import Box from "@mui/material/Box";
import TitlePages from "../../../../components/generic/titlePages";
import SubTitlePages from "../../../../components/generic/subTitlePages";


const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function TitleDashboard({ children }) {
  return (
    <Box>
      {children}
      <TitlePages>Relatório Estatístico</TitlePages>
      <SubTitlePages>Relatório de acompanhamento da carteira</SubTitlePages>
    </Box>
  );
}
